<template>
  <div v-if="alertFleetText" class="b-alert-line b-alert-line--width-short">
    <div class="b-alert-line__body">
      <div class="b-alert-line__aside"><IdeaLottie width="20" /></div>
      <div class="b-alert-line__main p" v-html="alertFleetText"></div>
    </div>
  </div>

  <div class="s-strip s-fleet-leaseitnow">
    <div class="page-container">
      <Loader v-if="isLoading" display="absolute"></Loader>
      <Alert v-if="errorMsgs.length" type="danger" :messages="errorMsgs" />

      <div class="s-fleet-leaseitnow__body">
        <div class="s-fleet-leaseitnow__aside">
          <LeaseItNowCalculator
            :auto-submit="true"
            @change-filters="onChangeFilters" />
        </div>

        <div class="s-fleet-leaseitnow__main">
          <div
            v-if="notEnoughFilters"
            class="s-fleet-leaseitnow__not-enough-filters">
            <i class="icon-search"></i>
            <span>{{ dictionary.filtersLabel }}</span>
          </div>
          <div v-else>
            <div
              v-if="recordsCount && !initial"
              class="s-fleet-leaseitnow__results-found mb-40 se">
              <div>
                {{ dictionary.resultsFoundPrefix }}
                <strong>
                  {{ records.length }} {{ dictionary.resultsFoundSuffix }}
                </strong>
                .
              </div>
              <div class="small">
                <i>{{ dictionary.photosIndicativeLabel }}</i>
              </div>
            </div>

            <div
              v-if="recordsCount"
              ref="grid"
              v-auto-animate
              class="s-fleet-leaseitnow__grid mb-60">
              <div
                v-for="item in recordsPaged"
                :key="item.vehicle_id"
                class="s-fleet-leaseitnow__item">
                <VehicleLeaseItNow
                  :item="item"
                  :records-compare="recordsCompare" />
              </div>
            </div>

            <div v-if="!recordsCount">
              <NoResults></NoResults>
            </div>

            <div v-if="recordsCount" class="d-flex justify-content-center">
              <Pagination
                class="mb-40"
                :total-records="recordsCount"
                :per-page="itemsPerPage"
                :current-page="page"
                @pagechanged="pageChanged" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Transition name="slide-up">
    <VehiclesCompareBar
      v-if="recordsCompare.length"
      :records="recordsCompare" />
  </Transition>
</template>

<script>
import jQuery from 'jquery'
import * as lib from './../../lib/lib'
import axios from 'axios'
import LeaseItNowCalculator from './LeaseItNowCalculator.vue'
import NoResults from '../components/common/NoResults.vue'
import Alert from '../components/common/Alert.vue'
import Loader from '../components/common/Loader.vue'
import { v4 as uuidv4 } from 'uuid'
import VehicleLeaseItNow from './../components/VehicleLeaseItNow.vue'
import VehiclesCompareBar from './../components/leaseitnow/VehiclesCompareBar.vue'
/* eslint-disable no-unused-vars */
import { remove } from 'lodash'
import mixinsLeaseItNow from './../mixins/leaseitnow-mixins'
import Pagination from './../components/common/Pagination.vue'
import IdeaLottie from './../components/lotties/Idea.vue'

export default {
  components: {
    Loader,
    Alert,
    LeaseItNowCalculator,
    NoResults,
    VehicleLeaseItNow,
    VehiclesCompareBar,
    Pagination,
    IdeaLottie,
  },
  mixins: [mixinsLeaseItNow],
  beforeRouteLeave () {
    this.showHeaderRequestOfferButton();
  },
  data() {
    return {
      key: uuidv4(),
      isLoading: false,
      errorMsgs: [],
      records: [],
      recordsCount: null,
      itemsPerPage: 15,
      page: 1,
      alertFleetText: null,
    }
  },
  computed: {
    initial() {
      return this.getFiltersCount() === 0
    },

    notEnoughFilters() {
      return this.getFiltersCount() === 1
    },
    recordsPaged() {
      const start = (this.page - 1) * this.itemsPerPage
      const end = this.page * this.itemsPerPage
      return this.records.slice(start, end)
    },
  },
  mounted() {
    this.hideHeaderRequestOfferButton();
    
    const { alertFleetText } = lib.getData('leaseItNowData')
    this.alertFleetText = alertFleetText
    this.getCars()
  },
  methods: {
    onChangeFilters() {
      if (this.notEnoughFilters) {
        console.log('not enough filters')
        return false
      }
      this.page = 1
      this.getCars()
    },

    getCars() {
      this.isLoading = true

      const postData = {
        models: this.getCarsPayload(),
        type: this.getTypeToken(),
        initial: this.initial,
      }

      axios
        .post(this.configuration.endpointGetCars, postData)
        .then((response) => {
          const { hasError, errorMessage } = response.data

          if (hasError) {
            this.handleError([errorMessage])
            return false
          }

          this.records = response.data
          this.recordsCount = this.records.length

          this.handleSuccess()
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },

    pageChanged(value) {
      this.page = value
      lib.scrollToElem(jQuery(this.$refs.grid), 100)
    },
  },
}
</script>
